// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"8cbf5ff1","247":"6c85c807","453":"3b728fee","570":"7fc0b89c","676":"6f9a7837","861":"d4fbc482","878":"edcd72ac","922":"469f23f4","964":"1f862989"}[chunkId] + ".chunk.js";
};